'use client';

import { useState } from 'react';

import Image from 'next/image';

import { LightBoxModal } from '@widgets/LightBoxModal';

import cls from './BlogPost.module.scss';

type BlogPostImageProps = {
  alt: string;
  imageUrl: string;
  imageUrls: string[];
};

export const BlogPostImage = ({ alt, imageUrl, imageUrls }: BlogPostImageProps) => {
  const [currentImageUrl, setCurrentImageUrl] = useState('');

  const handleOpenLightBox = () => {
    setCurrentImageUrl(imageUrl);
  };

  const handleCloseLightBox = () => {
    setCurrentImageUrl('');
  };

  return (
    <>
      <button
        className={cls.sectionImageButton}
        type="button"
        aria-label="Открыть изображение статьи"
        onClick={handleOpenLightBox}
      >
        <Image
          className={cls.image}
          src={imageUrl}
          alt={alt}
          fill
          sizes="(max-width: 767px) 100vw, 920px"
          unoptimized
        />
      </button>

      {currentImageUrl && (
        <LightBoxModal
          open={Boolean(currentImageUrl)}
          imageUrls={imageUrls}
          currentImageUrl={currentImageUrl}
          onClose={handleCloseLightBox}
        />
      )}
    </>
  );
};
